'use client';
import React from 'react';
import { Service } from './Service';
import httpCodes from '@/constants/httpCodes';
import { useForm } from 'antd/es/form/Form';
import { useTranslations } from 'next-intl';

export function useController() {
  const [loading, setLoading] = React.useState(false);
  const [apiError, setApiError] = React.useState('');
  const t = useTranslations('auth');
  // hooks
  const [form] = useForm();

  const handleContactEmail = async (payload: {
    names: string;
    email: string;
    message: string;
  }) => {
    setLoading(true);
    try {
      const response = await Service.contact(payload);
      setLoading(false);

      if (response.status === httpCodes.SUCCESS) {
        form.resetFields();
        setApiError('success');
      } else {
        setApiError('failure');
      }
    } catch (error) {
      setApiError('failure');
      setLoading(false);
    }
  };

  const getMessageAlert = () => {
    switch (apiError) {
      case 'success':
        return {
          type: 'success' as const,
          message: t('forms.labels.messageSubmitted'),
        };
      case 'failure':
        return {
          type: 'error' as const,
          message: t('forms.apiResponse.serverError'),
        };
    }
  };

  return {
    loading,
    handleContactEmail,
    form,
    getMessageAlert,
    apiError,
  };
}
